/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AggregateData } from '../model/aggregateData';
import { ApiRequestDto } from '../model/apiRequestDto';
import { AverageData } from '../model/averageData';
import { PharmacyChargesResultPharmacyChargeDetail } from '../model/pharmacyChargesResultPharmacyChargeDetail';
import { SummedAggregateData } from '../model/summedAggregateData';
import { SummedDataWithPercentage } from '../model/summedDataWithPercentage';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class FinancialService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Returns Billing Summary Data broken down by Projected, Unbilled, and Last Month.
     * Data in this call is aggregated. It also only accepts a single facility        Sample Call      http://URL/api/Financial/GetBillingSummaryData?orgUnit&#x3D;10wilm
     * @param orgUnit Single Organizational Unit for which to return data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetBillingSummaryData(orgUnit: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AggregateData>>;
    public financialGetBillingSummaryData(orgUnit: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AggregateData>>>;
    public financialGetBillingSummaryData(orgUnit: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AggregateData>>>;
    public financialGetBillingSummaryData(orgUnit: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling financialGetBillingSummaryData.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AggregateData>>(`${this.basePath}/api/Financial/GetBillingSummaryData`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for Non-Covered Charge Details (Grid Data).
     * Data in this call is not aggregated.        Sample Call      http://URL/api/Financial/GetNonCoveredChargeDetails
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetNonCoveredChargeDetails(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<PharmacyChargesResultPharmacyChargeDetail>;
    public financialGetNonCoveredChargeDetails(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PharmacyChargesResultPharmacyChargeDetail>>;
    public financialGetNonCoveredChargeDetails(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PharmacyChargesResultPharmacyChargeDetail>>;
    public financialGetNonCoveredChargeDetails(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetNonCoveredChargeDetails.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PharmacyChargesResultPharmacyChargeDetail>(`${this.basePath}/api/Financial/GetNonCoveredChargeDetails`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Non-Covered Pharmacy Charges total cost broken down by Facility and Order Type.  Order Type is Rx or OTC.
     * Data in this call is aggregated.        Sample Call      http://URL/api/Financial/GetNonCoveredChargesByFacilityAndOrderType
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetNonCoveredChargesByFacilityAndOrderType(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<SummedAggregateData>;
    public financialGetNonCoveredChargesByFacilityAndOrderType(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedAggregateData>>;
    public financialGetNonCoveredChargesByFacilityAndOrderType(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedAggregateData>>;
    public financialGetNonCoveredChargesByFacilityAndOrderType(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetNonCoveredChargesByFacilityAndOrderType.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedAggregateData>(`${this.basePath}/api/Financial/GetNonCoveredChargesByFacilityAndOrderType`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Non-Covered Pharmacy Charges total cost broken down by Pay Type. A \&quot;Pay Type\&quot; is a set of Invoice Group codes.
     * Data in this call is aggregated.        Sample Call      http://URL/api/Financial/GetNonCoveredChargesByPayType
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetNonCoveredChargesByFacilityAndPayType(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<SummedAggregateData>;
    public financialGetNonCoveredChargesByFacilityAndPayType(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedAggregateData>>;
    public financialGetNonCoveredChargesByFacilityAndPayType(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedAggregateData>>;
    public financialGetNonCoveredChargesByFacilityAndPayType(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetNonCoveredChargesByFacilityAndPayType.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedAggregateData>(`${this.basePath}/api/Financial/GetNonCoveredChargesByFacilityAndPayType`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Non-Covered Pharmacy Charges total cost broken down by Pay Type. A \&quot;Pay Type\&quot; is a set of Invoice Group codes.
     * Data in this call is aggregated.        Sample Call      http://URL/api/Financial/GetNonCoveredChargesByPayType
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetNonCoveredChargesByPayType(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<SummedAggregateData>;
    public financialGetNonCoveredChargesByPayType(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedAggregateData>>;
    public financialGetNonCoveredChargesByPayType(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedAggregateData>>;
    public financialGetNonCoveredChargesByPayType(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetNonCoveredChargesByPayType.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedAggregateData>(`${this.basePath}/api/Financial/GetNonCoveredChargesByPayType`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Non-Covered Pharmacy Charges total cost broken down by Pay Type. A \&quot;Pay Type\&quot; is a set of Invoice Group codes.
     * Data in this call is aggregated.        Sample Call      http://URL/api/Financial/GetNonCoveredChargesPercentage
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetNonCoveredChargesPercentage(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<SummedDataWithPercentage>;
    public financialGetNonCoveredChargesPercentage(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedDataWithPercentage>>;
    public financialGetNonCoveredChargesPercentage(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedDataWithPercentage>>;
    public financialGetNonCoveredChargesPercentage(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetNonCoveredChargesPercentage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedDataWithPercentage>(`${this.basePath}/api/Financial/GetNonCoveredChargesPercentage`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Raw data for Pharmacy Charge Details (Grid Data).
     * Data in this call is not aggregated.        Sample Call      http://URL/api/Financial/GetPharmacyChargeDetails?excludeHospiceCharges&#x3D;true
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param filename 
     * @param excludeHospiceCharges Whether to exclude HOS invoice group code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetPharmacyChargeDetails(requestParams: ApiRequestDto, filename: string, excludeHospiceCharges?: boolean, observe?: 'body', reportProgress?: boolean): Observable<PharmacyChargesResultPharmacyChargeDetail>;
    public financialGetPharmacyChargeDetails(requestParams: ApiRequestDto, filename: string, excludeHospiceCharges?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PharmacyChargesResultPharmacyChargeDetail>>;
    public financialGetPharmacyChargeDetails(requestParams: ApiRequestDto, filename: string, excludeHospiceCharges?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PharmacyChargesResultPharmacyChargeDetail>>;
    public financialGetPharmacyChargeDetails(requestParams: ApiRequestDto, filename: string, excludeHospiceCharges?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetPharmacyChargeDetails.');
        }

        if (filename === null || filename === undefined) {
            throw new Error('Required parameter filename was null or undefined when calling financialGetPharmacyChargeDetails.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filename !== undefined && filename !== null) {
            queryParameters = queryParameters.set('filename', <any>filename);
        }
        if (excludeHospiceCharges !== undefined && excludeHospiceCharges !== null) {
            queryParameters = queryParameters.set('excludeHospiceCharges', <any>excludeHospiceCharges);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PharmacyChargesResultPharmacyChargeDetail>(`${this.basePath}/api/Financial/GetPharmacyChargeDetails`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Pharmacy Charge Details Order By TotalPrice Descending (Grid Data)
     * Sample Call  http://URL/api/Financial/GetPharmacyChargeDetailsOrderedByTotalPrice?excludeHospiceCharges&#x3D;true
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param filename 
     * @param excludeHospiceCharges 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetPharmacyChargeDetailsOrderedByTotalPrice(requestParams: ApiRequestDto, filename: string, excludeHospiceCharges?: boolean, observe?: 'body', reportProgress?: boolean): Observable<PharmacyChargesResultPharmacyChargeDetail>;
    public financialGetPharmacyChargeDetailsOrderedByTotalPrice(requestParams: ApiRequestDto, filename: string, excludeHospiceCharges?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PharmacyChargesResultPharmacyChargeDetail>>;
    public financialGetPharmacyChargeDetailsOrderedByTotalPrice(requestParams: ApiRequestDto, filename: string, excludeHospiceCharges?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PharmacyChargesResultPharmacyChargeDetail>>;
    public financialGetPharmacyChargeDetailsOrderedByTotalPrice(requestParams: ApiRequestDto, filename: string, excludeHospiceCharges?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetPharmacyChargeDetailsOrderedByTotalPrice.');
        }

        if (filename === null || filename === undefined) {
            throw new Error('Required parameter filename was null or undefined when calling financialGetPharmacyChargeDetailsOrderedByTotalPrice.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filename !== undefined && filename !== null) {
            queryParameters = queryParameters.set('filename', <any>filename);
        }
        if (excludeHospiceCharges !== undefined && excludeHospiceCharges !== null) {
            queryParameters = queryParameters.set('excludeHospiceCharges', <any>excludeHospiceCharges);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PharmacyChargesResultPharmacyChargeDetail>(`${this.basePath}/api/Financial/GetPharmacyChargeDetailsOrderedByTotalPrice`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges total cost broken down by Facility and Pay Type. A \&quot;Pay Type\&quot; is a set of Invoice Groups.
     * Data in this call is aggregated.        Sample Call      http://URL/api/Financial/GetPharmacyChargesByFacility
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetPharmacyChargesByFacility(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<SummedAggregateData>;
    public financialGetPharmacyChargesByFacility(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedAggregateData>>;
    public financialGetPharmacyChargesByFacility(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedAggregateData>>;
    public financialGetPharmacyChargesByFacility(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetPharmacyChargesByFacility.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedAggregateData>(`${this.basePath}/api/Financial/GetPharmacyChargesByFacility`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges total cost broken down by Rx or OTC.
     * Sample Call  http://URL/api/Financial/GetPharmacyChargesByOrderType
     * @param requestParams Contains request parameters: startDate, endDate, orgList, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetPharmacyChargesByOrderType(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<SummedAggregateData>;
    public financialGetPharmacyChargesByOrderType(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedAggregateData>>;
    public financialGetPharmacyChargesByOrderType(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedAggregateData>>;
    public financialGetPharmacyChargesByOrderType(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetPharmacyChargesByOrderType.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedAggregateData>(`${this.basePath}/api/Financial/GetPharmacyChargesByOrderType`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges total cost broken down by Pay Type. A \&quot;Pay Type\&quot; is a set of Invoice Groups.
     * Data in this call is aggregated.        Sample Call      http://URL/api/Financial/GetPharmacyChargesByPayType
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetPharmacyChargesByPayType(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<SummedAggregateData>;
    public financialGetPharmacyChargesByPayType(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedAggregateData>>;
    public financialGetPharmacyChargesByPayType(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedAggregateData>>;
    public financialGetPharmacyChargesByPayType(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetPharmacyChargesByPayType.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedAggregateData>(`${this.basePath}/api/Financial/GetPharmacyChargesByPayType`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges total cost broken down top Prescribers.   Typically this call is made for top 5 or top 10. No \&quot;Other prescriber\&quot; group is returned in this call.
     * Sample Call  http://URL/api/Financial/GetPharmacyChargesByPrescriber?numberOfPrescribers&#x3D;5
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param numberOfPrescribers number of prescribers to be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetPharmacyChargesByPrescriber(requestParams: ApiRequestDto, numberOfPrescribers: number, observe?: 'body', reportProgress?: boolean): Observable<SummedAggregateData>;
    public financialGetPharmacyChargesByPrescriber(requestParams: ApiRequestDto, numberOfPrescribers: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedAggregateData>>;
    public financialGetPharmacyChargesByPrescriber(requestParams: ApiRequestDto, numberOfPrescribers: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedAggregateData>>;
    public financialGetPharmacyChargesByPrescriber(requestParams: ApiRequestDto, numberOfPrescribers: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetPharmacyChargesByPrescriber.');
        }

        if (numberOfPrescribers === null || numberOfPrescribers === undefined) {
            throw new Error('Required parameter numberOfPrescribers was null or undefined when calling financialGetPharmacyChargesByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (numberOfPrescribers !== undefined && numberOfPrescribers !== null) {
            queryParameters = queryParameters.set('numberOfPrescribers', <any>numberOfPrescribers);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedAggregateData>(`${this.basePath}/api/Financial/GetPharmacyChargesByPrescriber`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges total cost broken down by top Residents.   Typically this call is made for top 5 or top 10. No \&quot;Other Resident\&quot; group is returned in this call.
     * Sample Call  http://URL/api/Financial/GetPharmacyChargesByResident?numberOfResidents&#x3D;5
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param numberOfResidents number of residents to be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetPharmacyChargesByResident(requestParams: ApiRequestDto, numberOfResidents: number, observe?: 'body', reportProgress?: boolean): Observable<SummedAggregateData>;
    public financialGetPharmacyChargesByResident(requestParams: ApiRequestDto, numberOfResidents: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedAggregateData>>;
    public financialGetPharmacyChargesByResident(requestParams: ApiRequestDto, numberOfResidents: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedAggregateData>>;
    public financialGetPharmacyChargesByResident(requestParams: ApiRequestDto, numberOfResidents: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetPharmacyChargesByResident.');
        }

        if (numberOfResidents === null || numberOfResidents === undefined) {
            throw new Error('Required parameter numberOfResidents was null or undefined when calling financialGetPharmacyChargesByResident.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (numberOfResidents !== undefined && numberOfResidents !== null) {
            queryParameters = queryParameters.set('numberOfResidents', <any>numberOfResidents);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedAggregateData>(`${this.basePath}/api/Financial/GetPharmacyChargesByResident`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges total cost broken down by Pay Type. A \&quot;Pay Type\&quot; is a set of Invoice Groups.
     * Data in this call is aggregated.        Sample Call      http://URL/api/Financial/GetPharmacyChargesByPayType
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetPharmacyCostPerRx(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public financialGetPharmacyCostPerRx(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public financialGetPharmacyCostPerRx(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public financialGetPharmacyCostPerRx(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetPharmacyCostPerRx.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/Financial/GetPharmacyCostPerRx`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges total cost broken down by Pay Type. A \&quot;Pay Type\&quot; is a set of Invoice Groups.
     * Data in this call is aggregated.        Sample Call      http://URL/api/Financial/GetPharmacyChargesByPayType?billingCutoff&#x3D;30
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param billingCutoff 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetPharmacyCostPerRxByMonth(requestParams: ApiRequestDto, billingCutoff: number, observe?: 'body', reportProgress?: boolean): Observable<Array<AverageData>>;
    public financialGetPharmacyCostPerRxByMonth(requestParams: ApiRequestDto, billingCutoff: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AverageData>>>;
    public financialGetPharmacyCostPerRxByMonth(requestParams: ApiRequestDto, billingCutoff: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AverageData>>>;
    public financialGetPharmacyCostPerRxByMonth(requestParams: ApiRequestDto, billingCutoff: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetPharmacyCostPerRxByMonth.');
        }

        if (billingCutoff === null || billingCutoff === undefined) {
            throw new Error('Required parameter billingCutoff was null or undefined when calling financialGetPharmacyCostPerRxByMonth.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (billingCutoff !== undefined && billingCutoff !== null) {
            queryParameters = queryParameters.set('billingCutoff', <any>billingCutoff);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AverageData>>(`${this.basePath}/api/Financial/GetPharmacyCostPerRxByMonth`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges for top medication classes broken down by facility.   Typically this call is made for top 5 or top 10 medication classes. No \&quot;Other Medications Class\&quot; group is returned in this call.
     * Sample Call  http://URL/api/Financial/GetTopMedicationClassesByFacility?numberOfClasses&#x3D;10
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param numberOfClasses number of medication classes to be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetTopMedicationClassesByFacility(requestParams: ApiRequestDto, numberOfClasses: number, observe?: 'body', reportProgress?: boolean): Observable<SummedAggregateData>;
    public financialGetTopMedicationClassesByFacility(requestParams: ApiRequestDto, numberOfClasses: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedAggregateData>>;
    public financialGetTopMedicationClassesByFacility(requestParams: ApiRequestDto, numberOfClasses: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedAggregateData>>;
    public financialGetTopMedicationClassesByFacility(requestParams: ApiRequestDto, numberOfClasses: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetTopMedicationClassesByFacility.');
        }

        if (numberOfClasses === null || numberOfClasses === undefined) {
            throw new Error('Required parameter numberOfClasses was null or undefined when calling financialGetTopMedicationClassesByFacility.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (numberOfClasses !== undefined && numberOfClasses !== null) {
            queryParameters = queryParameters.set('numberOfClasses', <any>numberOfClasses);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedAggregateData>(`${this.basePath}/api/Financial/GetTopMedicationClassesByFacility`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges for top medication classes broken down by Order Type.   Typically this call is made for top 5 or top 10 medication classses. No \&quot;Other Medications Classes\&quot; group is returned in this call.
     * Sample Call  http://URL/api/Financial/GetTopMedicationClassesByOrderType
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetTopMedicationClassesByOrderType(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<SummedAggregateData>;
    public financialGetTopMedicationClassesByOrderType(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedAggregateData>>;
    public financialGetTopMedicationClassesByOrderType(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedAggregateData>>;
    public financialGetTopMedicationClassesByOrderType(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetTopMedicationClassesByOrderType.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedAggregateData>(`${this.basePath}/api/Financial/GetTopMedicationClassesByOrderType`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges for top medication classes broken down by Pay Type.   Typically this call is made for top 5 or top 10 medication classses. No \&quot;Other Medications Classes\&quot; group is returned in this call.
     * Sample Call  http://URL/api/Financial/GetTopMedicationClassesByPayType?numberOfClasses&#x3D;10
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param numberOfClasses number of medication classes to be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetTopMedicationClassesByPayType(requestParams: ApiRequestDto, numberOfClasses: number, observe?: 'body', reportProgress?: boolean): Observable<SummedAggregateData>;
    public financialGetTopMedicationClassesByPayType(requestParams: ApiRequestDto, numberOfClasses: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedAggregateData>>;
    public financialGetTopMedicationClassesByPayType(requestParams: ApiRequestDto, numberOfClasses: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedAggregateData>>;
    public financialGetTopMedicationClassesByPayType(requestParams: ApiRequestDto, numberOfClasses: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetTopMedicationClassesByPayType.');
        }

        if (numberOfClasses === null || numberOfClasses === undefined) {
            throw new Error('Required parameter numberOfClasses was null or undefined when calling financialGetTopMedicationClassesByPayType.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (numberOfClasses !== undefined && numberOfClasses !== null) {
            queryParameters = queryParameters.set('numberOfClasses', <any>numberOfClasses);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedAggregateData>(`${this.basePath}/api/Financial/GetTopMedicationClassesByPayType`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges for top medication classes broken down by prescriber.   Typically this call is made for top 5 or top 10 classes. No \&quot;Other Medications Classes\&quot; group is returned in this call.
     * Sample Call  http://URL/api/Financial/GetTopMedicationClassesByPrescriber?numberOfClasses&#x3D;10
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param numberOfClasses number of medication classes to be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetTopMedicationClassesByPrescriber(requestParams: ApiRequestDto, numberOfClasses: number, observe?: 'body', reportProgress?: boolean): Observable<SummedAggregateData>;
    public financialGetTopMedicationClassesByPrescriber(requestParams: ApiRequestDto, numberOfClasses: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedAggregateData>>;
    public financialGetTopMedicationClassesByPrescriber(requestParams: ApiRequestDto, numberOfClasses: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedAggregateData>>;
    public financialGetTopMedicationClassesByPrescriber(requestParams: ApiRequestDto, numberOfClasses: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetTopMedicationClassesByPrescriber.');
        }

        if (numberOfClasses === null || numberOfClasses === undefined) {
            throw new Error('Required parameter numberOfClasses was null or undefined when calling financialGetTopMedicationClassesByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (numberOfClasses !== undefined && numberOfClasses !== null) {
            queryParameters = queryParameters.set('numberOfClasses', <any>numberOfClasses);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedAggregateData>(`${this.basePath}/api/Financial/GetTopMedicationClassesByPrescriber`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges for top medications broken down by facility.   Typically this call is made for top 5 or top 10 medications. No \&quot;Other Medications\&quot; group is returned in this call.
     * Sample Call  http://URL/api/Financial/GetTopMedicationsByFacility?numberOfMedications&#x3D;10
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param numberOfMedications number of medications to be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetTopMedicationsByFacility(requestParams: ApiRequestDto, numberOfMedications: number, observe?: 'body', reportProgress?: boolean): Observable<SummedAggregateData>;
    public financialGetTopMedicationsByFacility(requestParams: ApiRequestDto, numberOfMedications: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedAggregateData>>;
    public financialGetTopMedicationsByFacility(requestParams: ApiRequestDto, numberOfMedications: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedAggregateData>>;
    public financialGetTopMedicationsByFacility(requestParams: ApiRequestDto, numberOfMedications: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetTopMedicationsByFacility.');
        }

        if (numberOfMedications === null || numberOfMedications === undefined) {
            throw new Error('Required parameter numberOfMedications was null or undefined when calling financialGetTopMedicationsByFacility.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (numberOfMedications !== undefined && numberOfMedications !== null) {
            queryParameters = queryParameters.set('numberOfMedications', <any>numberOfMedications);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedAggregateData>(`${this.basePath}/api/Financial/GetTopMedicationsByFacility`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges for top medications broken down by Pay Type.   Typically this call is made for top 5 or top 10 medications. No \&quot;Other Medications\&quot; group is returned in this call.
     * Sample Call  http://URL/api/Financial/GetTopMedicationsByPayType?numberOfMedications&#x3D;10
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param numberOfMedications number of medications to be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetTopMedicationsByPayType(requestParams: ApiRequestDto, numberOfMedications: number, observe?: 'body', reportProgress?: boolean): Observable<SummedAggregateData>;
    public financialGetTopMedicationsByPayType(requestParams: ApiRequestDto, numberOfMedications: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedAggregateData>>;
    public financialGetTopMedicationsByPayType(requestParams: ApiRequestDto, numberOfMedications: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedAggregateData>>;
    public financialGetTopMedicationsByPayType(requestParams: ApiRequestDto, numberOfMedications: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetTopMedicationsByPayType.');
        }

        if (numberOfMedications === null || numberOfMedications === undefined) {
            throw new Error('Required parameter numberOfMedications was null or undefined when calling financialGetTopMedicationsByPayType.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (numberOfMedications !== undefined && numberOfMedications !== null) {
            queryParameters = queryParameters.set('numberOfMedications', <any>numberOfMedications);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedAggregateData>(`${this.basePath}/api/Financial/GetTopMedicationsByPayType`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges for top medications broken down by prescriber.   Typically this call is made for top 5 or top 10 medications. No \&quot;Other Medications\&quot; group is returned in this call.
     * Sample Call  http://URL/api/Financial/GetTopMedicationsByPrescriber?numberOfMedications&#x3D;10
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param numberOfMedications number of medications to be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetTopMedicationsByPrescriber(requestParams: ApiRequestDto, numberOfMedications: number, observe?: 'body', reportProgress?: boolean): Observable<SummedAggregateData>;
    public financialGetTopMedicationsByPrescriber(requestParams: ApiRequestDto, numberOfMedications: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SummedAggregateData>>;
    public financialGetTopMedicationsByPrescriber(requestParams: ApiRequestDto, numberOfMedications: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SummedAggregateData>>;
    public financialGetTopMedicationsByPrescriber(requestParams: ApiRequestDto, numberOfMedications: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetTopMedicationsByPrescriber.');
        }

        if (numberOfMedications === null || numberOfMedications === undefined) {
            throw new Error('Required parameter numberOfMedications was null or undefined when calling financialGetTopMedicationsByPrescriber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (numberOfMedications !== undefined && numberOfMedications !== null) {
            queryParameters = queryParameters.set('numberOfMedications', <any>numberOfMedications);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SummedAggregateData>(`${this.basePath}/api/Financial/GetTopMedicationsByPrescriber`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a summary value for all non-covered charges in the selected date range for the selected facilities.
     * Sample Call  http://URL/api/Financial/GetTotalNonCoveredCharges
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetTotalNonCoveredCharges(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public financialGetTotalNonCoveredCharges(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public financialGetTotalNonCoveredCharges(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public financialGetTotalNonCoveredCharges(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetTotalNonCoveredCharges.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/Financial/GetTotalNonCoveredCharges`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get summary records for all non-covered charges for the selected date range for the selected facilities.  Order Type is Rx or OTC.
     * Data in this call is aggregated.        Sample Call      http://URL/api/Financial/GetTotalNonCoveredChargesByMonth?billingCutoff&#x3D;30
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param billingCutoff 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetTotalNonCoveredChargesByMonth(requestParams: ApiRequestDto, billingCutoff: number, observe?: 'body', reportProgress?: boolean): Observable<Array<AverageData>>;
    public financialGetTotalNonCoveredChargesByMonth(requestParams: ApiRequestDto, billingCutoff: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AverageData>>>;
    public financialGetTotalNonCoveredChargesByMonth(requestParams: ApiRequestDto, billingCutoff: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AverageData>>>;
    public financialGetTotalNonCoveredChargesByMonth(requestParams: ApiRequestDto, billingCutoff: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetTotalNonCoveredChargesByMonth.');
        }

        if (billingCutoff === null || billingCutoff === undefined) {
            throw new Error('Required parameter billingCutoff was null or undefined when calling financialGetTotalNonCoveredChargesByMonth.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (billingCutoff !== undefined && billingCutoff !== null) {
            queryParameters = queryParameters.set('billingCutoff', <any>billingCutoff);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AverageData>>(`${this.basePath}/api/Financial/GetTotalNonCoveredChargesByMonth`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges total cost broken down by Pay Type. A \&quot;Pay Type\&quot; is a set of Invoice Groups.
     * Data in this call is aggregated.        Sample Call      http://URL/api/Financial/GetPharmacyChargesByPayType
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetTotalPharmacyCost(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public financialGetTotalPharmacyCost(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public financialGetTotalPharmacyCost(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public financialGetTotalPharmacyCost(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetTotalPharmacyCost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/Financial/GetTotalPharmacyCost`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns Pharmacy Charges total cost broken down by Pay Type. A \&quot;Pay Type\&quot; is a set of Invoice Groups.
     * Data in this call is aggregated.        Sample Call      http://URL/api/Financial/GetPharmacyChargesByPayType?billingCutoff&#x3D;30
     * @param requestParams Contains request parameters: startDate, endDate, orgList
     * @param billingCutoff 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public financialGetTotalPharmacyCostByMonth(requestParams: ApiRequestDto, billingCutoff: number, observe?: 'body', reportProgress?: boolean): Observable<Array<AverageData>>;
    public financialGetTotalPharmacyCostByMonth(requestParams: ApiRequestDto, billingCutoff: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AverageData>>>;
    public financialGetTotalPharmacyCostByMonth(requestParams: ApiRequestDto, billingCutoff: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AverageData>>>;
    public financialGetTotalPharmacyCostByMonth(requestParams: ApiRequestDto, billingCutoff: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling financialGetTotalPharmacyCostByMonth.');
        }

        if (billingCutoff === null || billingCutoff === undefined) {
            throw new Error('Required parameter billingCutoff was null or undefined when calling financialGetTotalPharmacyCostByMonth.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (billingCutoff !== undefined && billingCutoff !== null) {
            queryParameters = queryParameters.set('billingCutoff', <any>billingCutoff);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AverageData>>(`${this.basePath}/api/Financial/GetTotalPharmacyCostByMonth`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
